import React from 'react';

const Yochisachi2026Page: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative min-h-screen flex flex-col items-center justify-center px-6 py-20 bg-gradient-to-b from-pink-50 to-white">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h1 className="text-5xl md:text-6xl font-bold text-purple-800 mb-4">
            <em>よっちゃんさっちゃん、</em>
          </h1>
          <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-6">
            <em>1万人フェスへの序章</em>
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            共同創造第1弾、舞台は
          </h3>
          <h2 className="text-4xl md:text-5xl font-bold mb-8">
            「<span className="text-purple-800"><em>日本武道館</em></span>」!
          </h2>
          
          <div className="my-12">
            <img 
              src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/9cbb6c03b5bc43e4bf460fa02311c311/original/Gemini_Generated_Image_gsulb4gsulb4gsul.png"
              alt="日本武道館"
              className="w-full max-w-3xl mx-auto rounded-lg shadow-2xl"
            />
          </div>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
            この武道館の夜は、魂の変容のクライマックス。あなたは歴史の証人となり、この奇跡を「一緒に創る」。148名が4ヶ月かけて自分自身を超えてきた、魂の叫びを目撃せよ。
          </p>

          <p className="text-lg md:text-xl font-bold text-red-600 my-6">
            【限定33枚】共同創造第0期参加権、解禁。
          </p>

          <p className="text-lg md:text-xl text-gray-700 mb-8">
            武道館2階特別席で、伝説の始まりに立ち会え!
          </p>

          <a 
            href="https://love-is-all-0808.jp/p/campaign/Pfzldsq0/4iGEX603" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold text-lg px-12 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            共同創造第0期参加権に申し込む
          </a>
        </div>
      </section>

      {/* Heart Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-pink-100 to-pink-50">
        <div className="max-w-5xl mx-auto text-center space-y-12">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-800 mb-8">
            <em>あなたの心の奥で、</em>
          </h2>
          <h2 className="text-4xl md:text-5xl font-bold text-purple-800 mb-12">
            <em>ずっと何かが叫んでいませんか?</em>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            <div className="bg-white p-8 rounded-2xl shadow-md border-2 border-pink-200">
              <h4 className="text-xl font-bold text-gray-800">
                本気で生きている人のエネルギーに触れたい
              </h4>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-md border-2 border-pink-200">
              <h4 className="text-xl font-bold text-gray-800">
                魂が震えるような体験をしたい
              </h4>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-md border-2 border-pink-200">
              <h4 className="text-xl font-bold text-gray-800">
                最高の仲間を応援したい
              </h4>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-md border-2 border-pink-200">
              <h4 className="text-xl font-bold text-gray-800">
                人生が変わる瞬間を、自分の目で見たい
              </h4>
            </div>
          </div>

          <p className="text-lg md:text-xl text-gray-700 mt-12">
            その声は、未来のあなたからの招待状である。
          </p>
        </div>
      </section>

      {/* Destiny Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                運命の幕開け。2026年1月14日、日本武道館。
              </h2>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800 leading-relaxed">
                この日行われるのは、ただのライブイベントではない。恐れを越え、過去を手放し、魂の声を取り戻すために歩き続けた4ヶ月間。その変容プロジェクトを終えた148名の、まさに<span className="text-red-600 font-bold">「魂の誕生」</span>を祝う神聖な儀式である。
              </h3>
            </div>
            <div>
              <img 
                src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/18e4b0c4f18a4622a781eb52f7cfbedb/original/Gemini_Generated_Image_fwsbzwfwsbzwfwsb.png"
                alt="武道館ステージ"
                className="w-full rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Witness Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-6">
                歴史の証人として
              </h2>
            </div>
            <div className="space-y-6">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                あなたには、その瞬間をただ座って観るのではなく、歴史の証人として、そして<strong>「共同創造第0期メンバー」</strong>として立ち会ってほしい。
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                それが、今回わずか<span className="text-red-600 font-bold">33名だけ</span>に用意された特別なオファーである。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Special Seats Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/mluzuh2xk988qd3/d0b665d210514f6994def5d3fc64f7d0/original/uuid-67D1CA28-3FFE-4A2D-9377-942E504A751C-code-001-library-1-type-1-mode-1-loc-true-cap-true.png"
                alt="武道館座席"
                className="w-full rounded-lg shadow-xl"
              />
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                なぜ、あえて「<span className="text-red-600">武道館2階席</span>」なのか?
              </h2>
              <h3 className="text-2xl md:text-3xl font-bold text-red-600">
                選ばれた33名だけが体験できる、
              </h3>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800">
                究極の視点。
              </h3>
              <h4 className="text-xl md:text-2xl font-bold text-gray-700">
                今回、「<span className="text-red-600"><em>共同創造第0期参加権</em></span>」としてご用意したのは、
              </h4>
              <h4 className="text-xl md:text-2xl font-bold text-gray-700">
                本来は一般販売されない特別なエリアの座席である
              </h4>
              <h4 className="text-xl md:text-2xl font-bold text-gray-700">
                。<span className="text-red-600 font-bold">「魂の門出を心から応援したい」</span>という、コアな仲間のためにのみ限定開放する。
              </h4>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Reasons Section */}
      <section className="py-20 px-6 bg-red-600 text-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16">
            3つの特別な理由
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white text-gray-900 p-8 rounded-2xl border-4 border-white shadow-xl">
              <div className="text-5xl font-bold text-red-600 mb-4 text-center">1</div>
              <h3 className="text-xl md:text-2xl font-bold mb-4">
                「武道館という宇宙」を一望する特等席
              </h3>
              <p className="text-gray-700 leading-relaxed">
                武道館の心臓部を見下ろす、あなただけの天空の桟敷席です。ステージ上の情熱、壮麗な合唱団のフォーメーション、光と音の魔法が織りなす空間演出が、まるで絵画のように調和します。この特等席から、武道館という名の生命体が鼓動する瞬間を目撃してください。
              </p>
            </div>

            <div className="bg-white text-gray-900 p-8 rounded-2xl border-4 border-white shadow-xl">
              <div className="text-5xl font-bold text-red-600 mb-4 text-center">2</div>
              <h3 className="text-xl md:text-2xl font-bold mb-4">
                魂の振動が最も調和して届く距離
              </h3>
              <p className="text-gray-700 leading-relaxed">
                近すぎず、遠すぎない奇跡的な距離感で、ステージ上の純粋なエネルギーが武道館の神聖な空間と共鳴します。魂の振動が全身を優しく包み込み、深い感動へと誘う聖域です。この席は、あなたの魂が解き放たれるゲートとなるでしょう。
              </p>
            </div>

            <div className="bg-white text-gray-900 p-8 rounded-2xl border-4 border-white shadow-xl">
              <div className="text-5xl font-bold text-red-600 mb-4 text-center">3</div>
              <h3 className="text-xl md:text-2xl font-bold mb-4">
                わずか33枚限定のプレミアムな権利
              </h3>
              <p className="text-gray-700 leading-relaxed">
                この無二の体験は、選ばれし33名にのみ許された、文字通り「一生に一度」のプレミアムな招待状です。これは単なるチケットではなく、1万人フェスという未来の伝説の幕開けを目撃する、歴史の証人となる権利。あなたの存在が、この壮大な物語の最初のページを飾るでしょう。
              </p>
            </div>
          </div>

          <p className="text-lg md:text-xl text-center mt-12">
            あなたは、この最も美しい視界の席から、148名の魂が輝く瞬間を見届けることができる。
          </p>
        </div>
      </section>

      {/* Performers Section */}
      <section className="py-20 px-6 bg-pink-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              舞台に立つ魂のナビゲーターたち
            </h2>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8">
              あなたの旅を導く、エネルギーの共鳴者
            </h3>
            <p className="text-lg text-gray-700">
              この夜、武道館のステージに立ち、魂の響きを届けるナビゲーターたちをご紹介する。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/a7e515634c9967fe3150ce0a57fc8729.png"
                  alt="穴口 恵子"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">穴口 恵子</h4>
              <p className="text-sm text-gray-600">~レムリアの女神~</p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/8362a485680ccce7c1c18d6e9777dff2.png"
                  alt="マミイ"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">マミイ</h4>
              <p className="text-sm text-gray-600">~量子ボイスの専門家~</p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/66978c7dd2c4bc662e2878982afa9547.png"
                  alt="Shingo Ryu"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">Shingo Ryu</h4>
              <p className="text-sm text-gray-600">~龍の叡智を響かせるクリエイティブ・ドラゴニスト~</p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/8dff83d956647995dd10255708a97eac.png"
                  alt="PICO"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">PICO</h4>
              <p className="text-sm text-gray-600">~奇跡を運ぶハッピーボイス~</p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/cae431301625f541c6b718c7d086a0b0.png"
                  alt="MIROKU"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">MIROKU</h4>
              <p className="text-sm text-gray-600">~Make the Impossible Possible~</p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/844f1ee86b39af25b75a3170ca95c7c2.png"
                  alt="朴井義展・幸花"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">朴井義展・幸花</h4>
              <p className="text-sm text-gray-600">~愛と笑いで地球をひとつにするスピリチュアルリーダー~</p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/ad0cad20b914bceebafd1e3fc784d17e.png"
                  alt="kayakaya"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">kayakaya</h4>
              <p className="text-sm text-gray-600">〜レムリア覚醒アウェイクナー〜</p>
            </div>

            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/371400442b9eae88fad35f24dd66f3c6.png"
                  alt="MIMI"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="font-bold text-gray-900 mb-1">MIMI</h4>
              <p className="text-sm text-gray-600">〜ボイスの専門家~</p>
            </div>
          </div>

          <p className="text-lg md:text-xl text-gray-700 text-center mt-12">
            彼らのリードのもと、会場はかつてないエネルギーの渦に包まれる。
          </p>
        </div>
      </section>

      {/* Closing Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/6eada1cec406a2ad946470c06b6c4eea.png"
                alt="参加への誘い"
                className="w-full rounded-lg shadow-xl"
              />
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                あなたが体験するのは、"ただの観覧"ではない。
              </h2>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                これは、魂の変容を見届ける儀式であり、あなた自身の変容の始まりである。
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                不思議なことに、ステージで覚醒していく魂たちを観ているあなた自身も、変わり始める。なぜなら、<span className="text-red-600 font-bold">覚醒は伝播する</span>からである。
              </p>
              <hr className="my-8 border-gray-300" />
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                <strong>さあ、準備はいいか?</strong>
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                1万人フェスへと続く、共同創造の壮大な旅路。その最初の伝説を、武道館で共に創ろう。
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                選ばれた33名の第0期メンバーとしての参加を、心からお待ちしている。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="apply" className="py-20 px-6 bg-gradient-to-b from-pink-50 to-white">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-6">
            旅のクライマックス
          </h2>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            🌟2026年1月14日(水) 日本武道館🌟
          </h1>

          <div className="bg-pink-100 border-4 border-pink-300 rounded-2xl p-8 md:p-12 space-y-6">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              ▼ 歴史的瞬間の証人となる権利を手に入れる ▼
            </h2>
            <h3 className="text-xl md:text-2xl font-bold text-gray-800">
              【限定33枚】共同創造第0期参加権<br />
              (武道館2階特別席での観覧権を含む)
            </h3>
            <h3 className="text-2xl md:text-3xl font-bold text-red-600">
              価格:8,000円(税込)
            </h3>
          </div>

          <a 
            href="https://love-is-all-0808.jp/p/campaign/Pfzldsq0/4iGEX603" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold text-lg px-12 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            共同創造第0期参加権に申し込む
          </a>

          <p className="text-sm text-gray-600 italic mt-6">
            ※限定数に達し次第、販売終了となります。完売後の追加は一切ありません。お早めにお申し込みください。
          </p>

          <hr className="my-12 border-gray-300" />

          {/* FAQ Section */}
          <div className="text-left space-y-8 mt-16">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-12">
              FAQ - よくある質問
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl border-2 border-gray-200 shadow-sm">
                <h4 className="text-lg font-bold text-gray-900 mb-3">
                  Q. 一人で行っても大丈夫ですか?
                </h4>
                <p className="text-gray-700">
                  A. はい、大丈夫である。ほとんどの方がお一人での参加である。会場全体が同じ想いを持った仲間であり、温かい雰囲気に包まれているので、安心して観覧いただける。
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border-2 border-gray-200 shadow-sm">
                <h4 className="text-lg font-bold text-gray-900 mb-3">
                  Q. いつチケットが届きますか?
                </h4>
                <p className="text-gray-700">
                  A. お申込み完了後、詳細をメールにてご案内いたします。
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border-2 border-gray-200 shadow-sm">
                <h4 className="text-lg font-bold text-gray-900 mb-3">
                  Q. 座席はどのあたりですか?
                </h4>
                <p className="text-gray-700">
                  A. ステージ全体、会場全体を見渡せる2階の特別エリアとなる。具体的な座席位置は当日ご案内いたします。
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl border-2 border-gray-200 shadow-sm">
                <h4 className="text-lg font-bold text-gray-900 mb-3">
                  Q. 33枚は追加されますか?
                </h4>
                <p className="text-gray-700">
                  A. いいえ、追加販売はない。今回限りの特別開放枠のため、33枚が完売した時点で終了となる。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Yochisachi2026Page;
